<template>
  <el-row class="warp rolediv" style="height: 100%; width: 100%">
    <el-tabs
      class="roleManagerTabBox product_management_box"
      v-model="activeName"
    >
      <el-tab-pane name="first">
        <span slot="label" style="padding: 0 15px">合同明细</span>
        <div class="product_tab_1 outer_tab">
          <!--收起内容-->
          <div class="pulldownbox info-container" v-show="!showQueryFilter">
            <i class="el-icon-info"></i>
            <span>查询条件</span>
            <span class="pulldownbtn" @click="pulldown"
              >展开<i class="el-icon-arrow-down"></i
            ></span>
          </div>
          <!--展开内容-->
          <div
            style="width: 100%"
            class="expandbox info-container"
            v-show="showQueryFilter"
          >
            <el-form
              class="product_filter_form"
              :model="filterForm"
              inline
              ref="filterForm"
              size="small"
              label-width="120px"
            >
              <el-form-item label="服务组织名称:" prop="serverName">
                <el-input
                  class="textInput"
                  v-model="filterForm.serverName"
                  placeholder="请输入服务组织名称"
                ></el-input>
              </el-form-item>

              <el-form-item label="农户所在乡镇:" prop="townName">
                <el-input
                  class="textInput"
                  v-model="filterForm.townName"
                  placeholder="请输入农户所在乡镇"
                ></el-input>
              </el-form-item>

              <el-form-item label="农户所在村:" prop="villageName">
                <el-input
                  class="textInput"
                  v-model="filterForm.villageName"
                  placeholder="请输入农户所在村"
                ></el-input>
              </el-form-item>

            </el-form>
            <el-row style="text-align: center; margin: 5px 0">
              <el-button @click="queryBtnClick" type="primary" size="small"
                >查询</el-button
              >
              <el-button @click="resetFilter" type="primary" plain size="small"
                >重置</el-button
              >
              <span class="pullupbtn" @click="pullup"
                >收起<i class="el-icon-arrow-up"></i
              ></span>
            </el-row>
          </div>
          <div
            style="height: 100%; position: relative"
            class="tablebox info-container"
          >
            <!--总计内容-->
            <el-row class="count_content">
              <i class="el-icon-success icon-table-summary"></i>
              <span
                >共查询到
                <span class="count_number">{{ totalItems }}</span> 条数据</span
              >
              <div
                style="display: inline-block; float: right; padding-right: 10px"
              >
                <el-button type="primary" size="small" @click="exportData" :disabled="!totalItems">导出</el-button
                >
              </div>
            </el-row>
            <!--table-->
            <div style="height: 100%; position: relative">
              <el-table
                class="product_tab_1_table"
                :data="tableData"
                ref="dataTable"
                @current-change="handleCurrentChange"
                height="100%"
                highlight-current-row
              >
                <el-table-column
                  type="index"
                  align="center"
                  label="序号"
                  width="80"
                ></el-table-column>
                <el-table-column
                  prop="serverName"
                  label="服务组织名称"
                  min-width="30"
                  :formatter="formatterFn"
                >
                </el-table-column>
                <el-table-column
                  prop="partyAName"
                  label="托管合同甲方"
                  min-width="30"
                  :formatter="formatterFn"
                >
                </el-table-column>
                <el-table-column
                  prop="partyACard"
                  label="托管合同甲方身份证号"
                  min-width="25"
                  :formatter="formatterFn"
                ></el-table-column>
                <el-table-column
                  prop="partyBName"
                  label="承包方代表姓名"
                  min-width="25"
                  :formatter="formatterFn"
                ></el-table-column>
                <el-table-column
                  prop="verifyArea"
                  label="核查面积（亩）"
                  min-width="25"
                  :formatter="formatterFn"
                ></el-table-column>
                <el-table-column
                  prop="townName"
                  label="农户所在乡镇"
                  min-width="25"
                  :formatter="formatterFn"
                ></el-table-column>
                <el-table-column
                  prop="villageName"
                  label="农户所在村"
                  min-width="25"
                  :formatter="formatterFn"
                ></el-table-column>
              </el-table>
            </div>
            <!--分页工具-->
            <el-row class="page-row">
              <el-pagination
                background
                :page-size="pageSize"
                :current-page.sync="currentPage"
                @current-change="currentChange"
                layout="prev, pager, next, jumper"
                :total="totalItems"
              >
              </el-pagination>
            </el-row>
          </div>
        </div>
      </el-tab-pane>
    </el-tabs>
  </el-row>
</template>

<script>
import API from "@/api/api_contract/api_contract.js";
export default {
  name: "contract-list",
  data() {
    return {
      activeName: "first",
      filterForm: {
        serverName: '',
        villageName: '',
        townName: ''
      },
      currentPage: 1 /*分页工具当前选中页*/,
      pageSize: 10,
      totalItems: 0 /*数据总条数*/,
      showQueryFilter: true /*是否显示搜索条件*/,
      tableData: [] /*table数据源*/,
      params: {}, // 查询参数
    };
  },
  created() {
  },
  beforeDestroy() {
  },
  mounted() {
    this.init();
  },
  methods: {
    async exportData() {
      try {
        let res = await API.handleDowuloadFile({
          serverName: this.filterForm.serverName,
          villageName: this.filterForm.villageName,
          townName: this.filterForm.townName,
        })

        if(res){
          this.GLOBAL.downloadBlobFile(res,'合同明细表', "xls", 'project')
        } else{
          console.log(res.msg || '导出数据错误')
        }
      } catch (error) {
        console.log(error || '导出数据异常')
      }
    },
    formatterFn(row, column, cellValue, index) {
      if (!cellValue) {
        return "--";
      }
      return cellValue;
    },
    /*页面初始化*/
    init() {
      this.getParams();
      this.getList()
    },
    //  参数设置
    getParams() {
      let form = this.filterForm;
      this.params = {
        serverName:form.serverName ,
        villageName: form.villageName,
        townName: form.townName,
        page: this.currentPage, // 页数
        pageSize: this.pageSize
      };
    },
    //列表接口
    async getList() {
      const { code, data } = await API.getContractList(this.params);
      if (code === 0) {
        this.totalItems = data.total;
        this.tableData = data.list;
      }
    },
    /*分页工具换页*/
    currentChange(val) {
      this.currentPage = val;
      this.params.page = val;
      this.getList();
    },

    /*点击查询按钮*/
    queryBtnClick() {
      this.currentPage = 1;
      this.getParams();
      this.getList();
    },

    /*点击重置按钮*/
    resetFilter() {
      this.filterForm.page = this.currentPage = 1; // 页数
      this.filterForm = {
        serverName: '',
        villageName: '',
        townName: ''
      }

      this.getParams()
      this.getList();
    },

    /*table选中行回调方法*/
    handleCurrentChange(val) {
      this.currentRow = val;
    },

    /*收起按钮*/
    pullup() {
      this.showQueryFilter = false;
    },

    /*展开按钮*/
    pulldown() {
      this.showQueryFilter = true;
    },
  },
};
</script>
<style lang="less">
el-dialog__header {
  background: red;
  text-align: center;
}
</style>




// WEBPACK FOOTER //
// src/studio/contract/contractDetails/main.vue